import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
  transform (value: any): Date | null {
    console.log(value)

    if (!value) return null

    if (value instanceof Date) {
      return value // Si ya es una instancia de Date, simplemente la devuelve.
    }

    if (typeof value === 'string' && value.includes('T')) {
      console.log(value)

      const [year, month, day] = value.split('T')[0].split('-').map(Number)
      const adjustedDate = new Date(year, month - 1, day)

      console.log('asd: ', adjustedDate)
      return adjustedDate
    }

    if (typeof value === 'string' && value.includes('/')) {
      const parts = value.split('/')
      console.log(parts)

      return new Date(+parts[2], +parts[1] - 1, +parts[0])
    }

    return null
  }
}
